(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["menu"] && !Shopify.designMode) return;
  try {
    function initMenuPopover(menuEl) {
    let activeSubmenu = null;
    let leaveTimer = null;

    function hideActive() {
      clearTimeout(leaveTimer);
      if (activeSubmenu) {
        activeSubmenu.hidePopover();
        activeSubmenu = null;
      }
    }

    function show(item, submenu) {
      clearTimeout(leaveTimer);
      if (activeSubmenu && activeSubmenu !== submenu) activeSubmenu.hidePopover();
      if (!submenu.matches(':popover-open')) {
        const rect = item.getBoundingClientRect();
        submenu.style.top = `${rect.bottom}px`;
        submenu.style.left = `${rect.left}px`;
        submenu.showPopover();
      }
      activeSubmenu = submenu;
    }

    function scheduleHide(e, item, submenu) {
      const related = e.relatedTarget;
      if (item.contains(related) || submenu.contains(related)) return;
      leaveTimer = setTimeout(hideActive, 100);
    }

    menuEl.querySelectorAll('.menu__item').forEach(item => {
      const submenu = item.querySelector('.menu__sublist[popover]');
      if (!submenu) return;

      item.addEventListener('mouseenter', () => show(item, submenu));
      item.addEventListener('mouseleave', (e) => scheduleHide(e, item, submenu));
      submenu.addEventListener('mouseenter', () => clearTimeout(leaveTimer));
      submenu.addEventListener('mouseleave', (e) => scheduleHide(e, item, submenu));
    });

    document.addEventListener('scroll', hideActive, { passive: true, capture: true });

    menuEl.addEventListener('mouseleave', (e) => {
      if (!menuEl.contains(e.relatedTarget)) leaveTimer = setTimeout(hideActive, 100);
    });
  }

  document.querySelectorAll('accordion-custom.menu--horizontal').forEach(initMenuPopover);
  } catch(e) { console.error(e); }
})();

})();
